(function (){
   const switchButton = document.getElementById('switch-contrast');

   //load saved contrast mode from session storage
   if(sessionStorage.getItem('contrast') === 'true') {
       switchContrast();
   }

   if(switchButton) {
       switchButton.addEventListener('click', () => {
           switchContrast();
           if(sessionStorage.getItem('contrast') === 'true') {
               sessionStorage.setItem('contrast', 'false')
           } else {
               sessionStorage.setItem('contrast', 'true')
           }
       })
   }

   function switchContrast() {
       document.body.classList.toggle('contrast');
   }
})();